import clsx from "clsx";
import { Typography } from "../Typography";
import styles from "./Badge.module.scss";
import { ReactNode } from "react";

type TBadgeProps = {
  children: ReactNode;
  bgColor?: string;
  className?: string;
};

export function Badge({ children, bgColor, className }: TBadgeProps) {
  return (
    <Typography
      className={clsx(styles.badge, className)}
      style={{ backgroundColor: bgColor || "var(--greyscale600)" }}
      variant="label-5"
      color="greyscale100"
    >
      {children}
    </Typography>
  );
}
